module.exports = __webpack_public_path__ + "img/psd.02efbbd7.svg";